import './styles/App.scss';
import {BrowserRouter as Router} from 'react-router-dom'
import AppRouter from "./_router";

function App() {
  return (
    <Router>
      <AppRouter/>
    </Router>
  );
}

export default App;
